const translations = {
  'barcelona.seo.title': 'Living & Teaching English in Barcelona | 2025 Cost of Living',
  'barcelona.seo.description':
    'Thinking of living and teaching English in Barcelona? Take a look at the inside information from TEFL Iberia, including cost of living, cultural tips and more.',
  'barcelona.sec1.title': 'Life in Barcelona',
  'barcelona.sec2.title': 'Living & Teaching English in Barcelona',
  'barcelona.sec2.description':
    'Barcelona, the capital of Catalunya (or Catalonia to Spanish speakers), is the economic and cultural powerhouse of northern Spain and home to over 3 million residents.',
  'barcelona.sec2.text1':
    'Situated between the Pyrenees mountain range and the Mediterranean, just 150 km from southern France, Barcelona has a lot going for it. You can lose yourself in the vibrant city centre, get away from it all in the stunning mountain scenery, or soak up the sun on one of the city’s many beaches.',
  'barcelona.sec2.text2':
    'Then there’s the stunning architecture and art – notably Antoni Gaudi’s modernist masterpieces and <strong>Joan Miró’s iconic sculptures</strong> – incredible food, rich local traditionals, countless festivals and, of course, fantastic nightlife.',

  'barcelona.sec3.titleL': 'Teaching English in Barcelona',
  'barcelona.sec3.titleR': 'The TEFL Jobs Market',
  'barcelona.sec3.textL1':
    'There’s endless fun to be had in Barcelona, but it also has unparalleled opportunities for English teachers. The Catalan population are ‘English conscientious’ and English-speaking abilities are highly regarded and sought-after. Many companies have English as a standard requirement for job entry.',
  'barcelona.sec3.textL2':
    'This means English schools and teachers are in constant demand. That’s why Barcelona is home to over 100 language academies and schools, all of which employ several teachers throughout the year, doing a mixture of courses for people of all ages – including specialist English courses for business and commerce.',
  'barcelona.sec3.textR1':
    ' The Spanish economy is now one of the fastest growing large economies in Europe. What’s more, the ability to speak English is increasingly in-demand for large and small businesses throughout the city. This is helped in no small part by the fact that <accentedLink> Barcelona is now one of the best cities for startups in Europe </accentedLink> , many of which use English as a primary language.',
  'barcelona.sec3.textR2': `So, it stands to reason that the <accentedLink> TEFL </accentedLink> jobs market in Spain continues to go from strength to strength, with hundreds of jobs posted every day.`,

  'barcelona.sec3.title': 'The Cost Of Living',
  'barcelona.sec3.description':
    'Barcelona is a large international city, and one of the biggest city brands on the planet. Still, the cost of living is much cheaper than other big European cities – or even most other US cities like New York and Miami',
  'barcelona.sec3.fact':
    'In fact, Barcelona is a far more affordable place than you might think. Here’s a cost of living comparison against a few big cities that our students regularly come from.',

  'barcelona.sec3.item': 'Item',
  'barcelona.sec3.barcelona': 'Barcelona',
  'barcelona.sec3.london': 'London',
  'barcelona.sec3.newYork': 'New York',
  'barcelona.sec3.austin': 'Austin',
  'barcelona.sec3.bedroomApartment': '1 bedroom in city-centre shared apartment',
  'barcelona.sec3.mealInExpensive': 'Meal at inexpensive restaurant',
  'barcelona.sec3.cappuccino': 'Cappuccino',
  'barcelona.sec3.beer': 'Large local beer in bar',
  'barcelona.sec3.metroTicket': '1-way metro ticket',
  'barcelona.sec3.kmInTaxi': '1 km in a taxi',
  'barcelona.sec3.source': 'Source',
  'barcelona.sec3.notification':
    'As you can see, Barcelona is a lot cheaper than its international counterparts! And this is another factor that makes the city a great place to live.',

  'barcelona.sec4.title': 'Making The Most Of Living In Barcelona',
  'barcelona.sec4.description':
    'We can’t rate Barcelona highly enough. After all, we have decided to settle here permanently and make the city our home!',
  'barcelona.sec4.text1': ` Delivering quality TEFL courses is our business, but we are also here to guide
  your entire experience. We’ve got your back from the very first step, with
  expert assistance when it comes to getting your
  <accentedLink>
    student visa
  </accentedLink>
  and we’ll also help you
  <accentedLink2>
    open your Spanish bank account
  </accentedLink2>
  . Our in-house accommodation service will help you get settled
  <accentedLink3>
    in the city
 </accentedLink3> , while our dedicated careers service will help you secure work post graduation.`,
  'barcelona.sec4.text2':
    'With secure foundations laid and the admin side of things in place, you’ll be ready to explore Barcelona in all its vibrant glory. And there really is something for everyone… quirky bars, late-night hangouts, colourful characters, massive festivals, beach parties, crazy culture, street art, outdoor pools, concerts, quiet parks, stunning architecture, amazing coffee, exotic cuisine … the list goes on! Honestly… you name it, Barcelona has it.',
  'barcelona.sec4.text3':
    'With that in mind, here’s just a snapshot of what you can expect from life in Barcelona…',

  'barcelona.sec5.title': 'Top Six Things To Do In Barcelona',
  'barcelona.sec5.description1': ` We’ve made Barcelona our home but the
  <strong>number of temporary residents in the city</strong> is enormous too and
  over 7 million tourists now arrive each year – including a huge proportion of
  English speakers who come to see what this city has to offer.`,
  'barcelona.sec5.description2':
    'Barcelona is such a popular destination for the fun, beaches, sangria, relaxation and nightlife, etcetera (we’ve covered most of this already) but making the most of life in the city needs a bit of inside knowledge to get beyond the tourist trappings.',
  'barcelona.sec5.readMore': 'Read more:',

  'barcelona.sec5.thing1.title': 'Party Till The Break Of Dawn',
  'barcelona.sec5.thing1.text':
    'Legendary music festivals, epic street parties, awesome night clubs, blissed-out beach parties – this city has everything. Open your mind, go with the flow, and Barcelona will take care of the rest.',
  'barcelona.sec5.thing1.link1': 'Top 5 festivals in Barcelona',
  'barcelona.sec5.thing1.link2': '5 Spanish festivals you’ve never heard of',
  'barcelona.sec5.thing1.link3': 'The 5 best bars in El Raval, Barcelona',

  'barcelona.sec5.thing2.title': 'Enjoy The Great Outdoors',
  'barcelona.sec5.thing2.text':
    'From breathtaking mountains to idyllic beaches, amazing adventures await those with a passion for nature and the great outdoors, with the outskirts of Barcelona and beyond offering a lifetime of incredible experiences.',
  'barcelona.sec5.thing2.link1': 'Top 5 outdoor activities in Catalonia',
  'barcelona.sec5.thing2.link2': 'Best day trips and weekend trips from Barcelona by train',
  'barcelona.sec5.thing2.link3': 'The five best beaches near Barcelona',

  'barcelona.sec5.thing3.title': 'Sample Some Amazing Cuisine',
  'barcelona.sec5.thing3.text':
    'Barcelona and Catalonia in general is renowned for its fantastic food, and there are so many incredible local dishes to discover when living in Barcelona. That’s just the half of it though. Thanks to Barcelona’s cosmopolitan feel, with such a diverse range of nationalities living in the city, foodies get to sample the best dishes from cultures the world over.',
  'barcelona.sec5.thing3.link1': 'A foodie guide to traditional cuisine in Barcelona',
  'barcelona.sec5.thing3.link2': 'TEFL Iberia’s vegan guide to Barcelona',
  'barcelona.sec5.thing3.link3': 'The five best brunches in Barcelona',

  'barcelona.sec5.thing4.title': 'Get Sporty',
  'barcelona.sec5.thing4.text': `The city is host to FC Barcelona… one of the most prestigious football teams in
  the history of the game. A <accentedLink>
    visit to Camp Nou
  </accentedLink> is a must for any sports fan and, with countless 5-a-side football pitches
  throughout the city, there are plenty of opportunities for football fanatics to
  get their fix. Add running tracks, basketball and padel courts, gyms, swimming
  pools and rock climbing centres into the mix and you’ve got a city that’s
  perfect for sports lovers.`,
  'barcelona.sec5.thing4.link1': 'Gym alternatives in Barcelona',
  'barcelona.sec5.thing4.link2': 'The five best workout spots in Barcelona',

  'barcelona.sec5.thing5.title': 'Be A Culture Vulture',
  'barcelona.sec5.thing5.text':
    'Barcelona has a rich artistic history, with the legacies of great painters, poets, writers and architects part of the fabric of the city. Whether visiting legendary spots like Bar Marsella or Els Quatre Gats (Picasso and Hemmingway hangouts, so they say), checking out local art exhibitions or taking advantage of free museums on the 1st Sunday of every month, there’s culture on every street corner in this wonderful city.',
  'barcelona.sec5.thing5.link1': 'The best bookshops in Barcelona',

  'barcelona.sec5.thing6.title': 'Live Like A Local',
  'barcelona.sec5.thing6.text': ` Once you’ve been in the city for a while and the honeymoon period comes to an
  end, you’ll find a deeper appreciation for local life. Soon you’ll be regaling
  your friends and family with stories of winter calçotadas and local festa
  majors, while discovering that you’re
  <accentedLink>
    picking up the habits of the locals!
  </accentedLink>`,
  'barcelona.sec5.thing6.link1': 'Our favourite terraces in Barcelona',
  'barcelona.sec5.thing6.link2': 'Where to go for Vermouth in Barcelona',
  'barcelona.sec5.thing6.link3': 'The TEFL Iberia guide to neighbourhoods of Barcelona',

  'barcelona.sec5.moreInfo': `For more about living and teaching English in Barcelona,
  <strong>
    take a look at one of our
  </strong>
  <accentedLink>
  recent blog posts.
</accentedLink>`,
};

export default translations;
